import React from 'react';
export function FailedAttempts() {
  const attempts = [{
    title: "Decirle 'no pasa nada'",
    desc: 'Invalida lo que siente en ese momento de dolor real.'
  }, {
    title: 'Dar consejos técnicos en el auto',
    desc: 'Aumenta su nivel de cortisol cuando más necesita apoyo emocional.'
  }, {
    title: "Presionarlos para que se 'animen'",
    desc: 'Les hace sentir que su tristeza es una carga adicional para ti.'
  }, {
    title: 'Enfocarse solo en el resultado final',
    desc: 'Les enseña que su valor como personas depende de un marcador.'
  }];
  return <section className="py-24 px-4 bg-warm-light" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <h2 className="text-3xl md:text-5xl font-black text-center text-warm-dark mb-16" data-id="element-16">
          ¿Por Qué Lo Que Has Intentado No Funciona?
        </h2>

        <div className="space-y-6" data-id="element-17">
          {attempts.map((item, index) => <div key={index} className="flex gap-6 items-start py-6 border-b border-warm-dark/10 last:border-b-0" data-id="element-18">
              <span className="font-heading font-bold text-2xl text-warm-dark/30 shrink-0 w-8" data-id="element-19">
                ✕
              </span>
              <div data-id="element-20">
                <h3 className="text-lg font-heading font-bold text-warm-dark mb-1" data-id="element-21">
                  {item.title}
                </h3>
                <p className="text-warm-mid" data-id="element-22">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}